<template>
    
   




    
</template>
<script>
import InfiniteSlideBar from '../components/InfiniteSlideBar.vue'

export default {
  components: {
    InfiniteSlideBar
  }
}
</script>
<style scoped>

</style>